export default [
    {
        title: 'Stadium',
        icon: { icon: 'tabler-box' },
        permissionIds: [35],
        children: [
            { title: 'QL góp ý', to: { name: 'stadium-feedback', meta: { permissionId: 35 } } },
        ],
    },
]
